import { styled } from "@mui/material/styles";

import BadgeStatus from "../../../../../components/Generic/BadgeStatus";

export const StatusBadge = styled(BadgeStatus)(() => ({
  height: "32px !important",
  minWidth: "65px !important",
  width: "fit-content",
  maxWidth: "148px !important",
  borderRadius: "100px !important",
  padding: "8px 12px !important",
  "& > span": {
    fontFamily: "Manrope",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: 0.5,
  },
}));
